"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = __importDefault(require("../../../../user/components/UserLinkTable/ToolBar/FilterSortPanel/styles"));
var SortButton_1 = __importDefault(require("./SortButton"));
exports.default = react_1.default.memo(function (_a) {
    var onChoose = _a.onChoose, currentlyChosen = _a.currentlyChosen, options = _a.options, noHeader = _a.noHeader;
    var classes = styles_1.default();
    var theme = core_1.useTheme();
    var isMobile = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    return (react_1.default.createElement(core_1.Grid, { container: true, item: true, direction: "column" },
        !noHeader && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Grid, { item: true, className: classes.sortHeaderGrid },
                react_1.default.createElement(core_1.Typography, { variant: isMobile ? 'h3' : 'caption', className: classes.sectionHeader }, isMobile ? 'Sort' : 'Sort by')),
            react_1.default.createElement(core_1.Grid, { item: true, className: classes.dividerGrid },
                react_1.default.createElement(core_1.Divider, { className: classes.divider })))),
        options.map(function (option) { return (react_1.default.createElement(core_1.Grid, { item: true, className: classes.sortButtonGrid, key: option.key },
            react_1.default.createElement(SortButton_1.default, { onClick: function () { return onChoose(option.key); }, columnLabel: option.label, isSelected: currentlyChosen === option.key }))); })));
});
